import PropTypes from 'prop-types';
import { useI18n } from '../../../../context/I18nContext';
import './CreateConversationButton.css';

const CreateConversationButton = ({
  fill = false,
  style = {},
  size = 24,
  onClick = () => {},
}) => {
  const { t } = useI18n();

  const mergedStyle = {
    display: 'inline-block',
    width: size + 'px',
    height: size + 'px',
    verticalAlign: 'middle',
    ...style,
  };

  let bubbleFill = 'none';
  let circleFill = 'none';
  let circleStroke = '#DE4858';
  let plusFill = '#DE4858';

  if (fill) {
    bubbleFill = '#DE4858';
    circleFill = '#DE4858';
    circleStroke = 'none';
    plusFill = '#F2F2F2';
  }

  const maskId = `mask-${Math.random().toString(36).substring(2, 11)}`;

  return (
    <div
      className="create-conversation-button"
      title={t('ContainerListView.startConversation')}
      onClick={onClick}
    >
      <svg width={size + 'px'} height={size + 'px'} viewBox="0 0 30 30" style={mergedStyle}>
        <defs>
          <mask id={maskId} maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="-1" y="-1" width="32" height="29">
            <rect x="-1" y="-1" width="32" height="29" fill="white" stroke="white" strokeWidth="1"></rect>
            <circle transform="translate(16.54, 15.05)" cx="6.5" cy="6.5" r="7.75" fill="black" stroke="black" strokeWidth="1"></circle>
        </mask>
      </defs>
      <g stroke="#DE4858" strokeWidth="1" fill={bubbleFill} fillRule="evenodd">
        <g mask={`url(#${maskId})`}>
              <g transform="translate(2.540000, 4.050000)">
                <path d="M12,0.1 C18.5677083,0.1 23.9166667,4.3625 23.9166667,9.608125 C23.9166667,12.07625 22.725,14.365625 20.5651042,16.06375 C18.3442708,17.81 15.3244792,18.765625 12.0677083,18.765625 C10.1109375,18.765625 8.61458333,18.559375 7.3484375,18.12625 C7.3078125,18.1125 7.26041667,18.091875 7.21302083,18.078125 C7.19270833,18.07125 7.17239583,18.064375 7.15885417,18.064375 C6.840625,17.968125 6.50208333,17.92 6.16354167,17.92 C5.784375,17.92 5.41197917,17.981875 5.05989583,18.09875 L5.05989583,18.09875 L5.03958333,18.105625 C4.99895833,18.119375 4.43697917,18.3325 4.29479167,18.40125 L4.29479167,18.40125 L1.61354167,19.58375 C2.54791667,16.565625 2.54791667,16.50375 2.54791667,16.31125 C2.54791667,15.823125 2.39895833,15.341875 2.12135417,14.9225 C2.0875,14.874375 2.05364583,14.82625 2.01302083,14.778125 C1.965625,14.71625 1.925,14.66125 1.89114583,14.62 C0.713020833,13.114375 0.0901041667,11.381875 0.0901041667,9.60125 C0.0833333333,4.3625 5.43229167,0.1 12,0.1 L12,0.1 Z"></path>
              </g>
          </g>
          <g transform="translate(16.540000, 15.050000)">
              <g strokeWidth="1" fillRule="evenodd" stroke={circleStroke} fill={circleFill}>
                <circle cx="6.5" cy="6.5" r="6.5"></circle>
              </g>
              <polygon strokeWidth="0" fill={plusFill} points="7.2781622 9.11160714 7.2781622 7.2781622 9.11160714 7.2781622 9.11160714 5.76826637 7.2781622 5.76826637 7.2781622 3.93482143 5.76826637 3.93482143 5.76826637 5.76826637 3.93482143 5.76826637 3.93482143 7.2781622 5.76826637 7.2781622 5.76826637 9.11160714"></polygon>
          </g>
        </g>
      </svg>
    </div>
  );
};

CreateConversationButton.propTypes = {
  fill: PropTypes.bool,
  style: PropTypes.object,
  size: PropTypes.number,
  onClick: PropTypes.func,
};

export default CreateConversationButton;
